/**
 * This enum is used for referring Local Storage Keys
 */
export enum LocalStorageEnum {
  AUTH0_DOMAIN = 'auth0_domain',
  USER_PROFILE = 'user_profile',
  EXPIRES_AT = 'expires_at',
  CONNECTION = 'auth0_connection',
}
